export default "__VITE_ASSET__DRsxOzhJ__"